import { registries } from './registries';

/**
 * Scoped Host UI API for one marketplace app (WordPress-plugin style).
 */
export const createAppHostApi = appCode => ({
  code: appCode,

  useManifest(manifest) {
    registries.manifests.set(appCode, manifest);
  },

  registerPage(pageKey, loader) {
    registries.pageLoaders.set(`${appCode}:${pageKey}`, loader);
  },

  registerSlotComponent(componentKey, loader) {
    registries.slotComponents.set(componentKey, loader);
  },
});

export const getSlotLoader = componentKey => registries.slotComponents.get(componentKey);

export const getPageLoader = (appCode, pageKey) => registries.pageLoaders.get(`${appCode}:${pageKey}`);

export const getManifest = appCode => registries.manifests.get(appCode);
